import { Component, OnInit } from '@angular/core';
import { AccountService, NotificationService, DeadlineService } from './modules/api';
import { MessagingService } from './shared/service/messaging.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import 'moment/min/locales';


const currentUser = JSON.parse(localStorage.getItem('currentUser'));
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  title = 'RMA';
  message;
  notifications;
  constructor(
    private messagingService: MessagingService,
    private as: AccountService,
    private ns: NotificationService,
    private translate: TranslateService,
    private dl: DeadlineService,
  ) {
    localStorage.removeItem('firebase:previous_websocket_failure');
    const _lang = (currentUser && currentUser.language) ? currentUser.language : 'en';
    this.translate.setDefaultLang(_lang);
    moment.locale(_lang);
  }

  ngOnInit() {
    if (currentUser) {
      this.as.apiAccountsUserProfileGet()
        .subscribe(data => {
          currentUser.name = data.fullName;
          currentUser.avatar = data.avatar;
          localStorage.setItem('currentUser', JSON.stringify(currentUser));
        });
      this.dl.apiGetDeadlineSetting()
        .subscribe(data => {
          localStorage.setItem('deadline', JSON.stringify(data));
        });
    }
    try {
      this.messagingService.getPermission();
      this.messagingService.receiveMessage();
      this.message = this.messagingService.currentMessage;
    } catch (e) {
      console.log('Unable to Listen PUSH Messages', e);
    }
  }
}
